/**
 * Local query keys for the stores area. `apps/web/src/lib/api.ts` (the shared
 * `queryKeys` export) is out of scope for this area's build-out, so these
 * live alongside the pages that use them.
 */
export const storeQueryKeys = {
  list: (q: string) => ['stores', 'list', q] as const,
  detail: (id: string) => ['stores', 'detail', id] as const,
  shelfLife: (id: string) => ['stores', 'shelfLife', id] as const,
  productSearch: (q: string) => ['stores', 'productSearch', q] as const,
  defaults: ['stores', 'defaults'] as const,
};
